import { Check } from '../components/Chrome'
import MacBook from '../components/MacBook'
import Pricing from '../components/Pricing'
import { AppIcon } from '../components/Chrome'
import { downloadURL } from '../lib/firebase'
import { useT } from '../i18n'

export default function Landing() {
  const t = useT()

  return (
    <main className="shell">
      <section className="hero">
        <div className="hero-icon"><AppIcon size={54} /></div>
        <h1>{t.hero.title}</h1>
        <p className="tagline">{t.hero.tagline}</p>
        <div className="hero-actions">
          <a className="btn btn-primary" href={downloadURL}>{t.hero.download}</a>
          <a className="btn btn-ghost" href="#pricing">{t.hero.seePricing}</a>
        </div>
        <p className="hero-note">{t.hero.note}</p>
        <MacBook />
      </section>

      <section id="features">
        <div className="section-head">
          <h2>{t.features.heading}</h2>
          <p>{t.features.sub}</p>
        </div>
        <div className="grid">
          {t.features.items.map((f) => (
            <article className="card" key={f.title}>
              <div className="card-glyph"><Check /></div>
              <h3>{f.title}</h3>
              <p>{f.body}</p>
            </article>
          ))}
        </div>
      </section>

      <Pricing />

      <section id="faq">
        <div className="section-head"><h2>{t.faq.heading}</h2></div>
        <div className="faq">
          {t.faq.items.map((item) => (
            <details key={item.q}>
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}
        </div>
      </section>

      <section id="layouts">
        <div className="section-head">
          <h2>{t.listMode.heading}</h2>
          <p>{t.listMode.sub}</p>
        </div>
        <div className="grid">
          <article className="card">
            <div className="card-glyph"><Check /></div>
            <h3>{t.listMode.grid.title}</h3>
            <p>{t.listMode.grid.body}</p>
          </article>
          <article className="card">
            <div className="card-glyph"><Check /></div>
            <h3>{t.listMode.list.title}</h3>
            <p>{t.listMode.list.body}</p>
          </article>
        </div>
      </section>
    </main>
  )
}
